import React, { useState } from 'react';
import { Page } from '../../layout';
import PageInstructions from '../../shared/components/PageInstructions';
import { useMutation } from '@apollo/client';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import { Input } from '@mui/material';
import SUBMIT_FEEDBACK from '../queries/submitFeedbackMutation';
import SuccessMessage from '../../shared/components/SuccessMessage';
import ApolloError from '../../shared/components/ApolloError';

const SubmitFeedbackPage = () => {
  const [input, setInput] = useState('');
  const [resultMessage, setResultMessage] = useState('');

  const [submitFeedback, { loading, error }] = useMutation(SUBMIT_FEEDBACK, {
    onCompleted: () => {
      setInput('');
      setResultMessage('Feedback has been submitted.');
    }
  });

  const pageTitle = 'Submit Feedback';
  const breadcrumbPathItems = [{ name: pageTitle, url: '' }];

  const handleOnChange = event => {
    setInput(event.target.value);
  };

  const handleSubmit = () => {
    if (input.length <= minCharacterLength) {
      return;
    }
    submitFeedback({ variables: { feedbackInput: input } });
  };

  if (error) {
    return <ApolloError />;
  }

  return (
    <Page title={pageTitle} className='submit-feedback'>
      <Breadcrumb pathItems={breadcrumbPathItems} />

      <PageInstructions title={pageTitle} />
      {resultMessage && <SuccessMessage message={resultMessage} />}
      <div className='input-container'>
        <div className='input-area'>
          <Input
            className='feedback-multiline-input'
            disableUnderline
            placeholder='Enter your feedback here. Feedback can be up to 500 characters in length.'
            onChange={handleOnChange}
            value={input}
            multiline={true}
            rows={5}
            inputProps={{ maxLength: maxCharacterLength }}
            disabled={loading}
          />
          <p>
            {input.length}/{maxCharacterLength}
          </p>
        </div>
        <button
          type='button'
          className='primary-button'
          onClick={handleSubmit}
          disabled={input.length <= minCharacterLength || loading}>
          Submit
        </button>
      </div>
    </Page>
  );
};

const maxCharacterLength = 500;
const minCharacterLength = 3;

export default SubmitFeedbackPage;
